module.exports = __webpack_public_path__ + "static/img/6.9036c6b1.jpg";